import "./DeviceFamilyTab.css";
import React from "react";
import {MC_Device} from "../../../common/iot/MC_Device";
import {Button, Divider, Paper} from "@mui/material";
import DetailRow from "../../../common/ui/DetailRow";
import {MC_Template_Role} from "../../../common/iot/MC_Parent_Template";
import {MC_Role_Entry} from "../../../common/iot/MC_Child_Roster";
import DeviceItemList from "../../../common/ui/item-list/list/DeviceItemList";
import AddChildDeviceToRoleDialog from "../../../common/ui/dialog/AddDialog/AddChildDeviceToRoleDialog";
import RemoveChildDeviceFromRoleDialog from "../../../common/ui/dialog/RemoveDialog/RemoveChildDeviceFromRoleDialog";

interface AddChildState {
    open: boolean;
    role: MC_Template_Role | null;
}
interface RemoveChildState {
    open: boolean;
    role: MC_Template_Role | null;
    child: MC_Device | null;
}
export interface DeviceFamilyTabProps {
    device: MC_Device;
}
function DeviceFamilyTab(props: DeviceFamilyTabProps) {
    const device: MC_Device = props.device;
    const configErr: string | null = device.parentConfigErr;
    const tRoles: MC_Template_Role[] = (device.parentTemplate != null) ? device.parentTemplate.roles : [];
    // UI State
    const [addChildState, setAddChildState] = React.useState<AddChildState>({open: false, role: null});
    const [removeChildState, setRemoveChildState] = React.useState<RemoveChildState>({open: false, role: null, child: null});
    // UI
    return (
        <div className={"dtab-root"}>
            {/* Dialogs */}
            <React.Fragment>
                <AddChildDeviceToRoleDialog
                    open={addChildState.open}
                    closeDialogFn={() => setAddChildState({open: false, role: addChildState.role})}
                    parent={device}
                    role={addChildState.role}
                    doneSuccessFn={() => {}}
                    doneFailureFn={() => {}}
                />
                <RemoveChildDeviceFromRoleDialog
                    open={removeChildState.open}
                    closeDialogFn={() => setRemoveChildState({open: false, role: removeChildState.role, child: removeChildState.child})}
                    parent={device}
                    role={removeChildState.role}
                    child={removeChildState.child}
                    doneSuccessFn={() => {}}
                    doneFailureFn={() => {}}
                />
            </React.Fragment>
            {/* Basic info */}
            <Paper className={"content-start"} elevation={3}>
                <DetailRow label={"Parent Config Status"}
                           color={(configErr != null) ? "bad" : "good"}
                           value={(configErr != null) ? "ERROR" : "OK"}
                />
                <DetailRow label={"Config Error"}
                           color={(configErr != null) ? "bad" : "gray"}
                           value={(configErr != null) ? configErr : "None"}/>
            </Paper>
            {/* Special edit paper for each template role */}
            {tRoles.map((role) => {
                return <React.Fragment>
                    <br/>
                    <ModifyTemplateRolePaper
                        device={device} role={role}
                        addChildFn={() => setAddChildState({open: true, role: role})}
                        removeChildFn={(d: MC_Device) => setRemoveChildState({open: true, role: role, child: d})}
                    />
                </React.Fragment>;
            })}
        </div>
    );
}

// UI displayed for each role
interface RolePaperProps {
    device: MC_Device;
    role: MC_Template_Role;
    addChildFn: () => void;
    removeChildFn: (d: MC_Device) => void;
}
function ModifyTemplateRolePaper(props: RolePaperProps) {
    const device = props.device;
    const role = props.role;
    const entries: MC_Role_Entry[] = device.childRoster.getEntries(role.id);
    const roleChildIDs: string[] = entries.map((x) => x.deviceID);
    const cCount: number = roleChildIDs.length;
    const canAddChild: boolean = (cCount < role.maxCount);
    // UI
    return <Paper className={"content-start"} elevation={3}>
        {/* Title */}
        <span className={"role-name-span"}>{role.name}</span>
        {/* <DetailRow label={"Template Role ID"} value={role.id}/> */}
        <DetailRow label={"Child Device Type"} value={role.deviceType}/>
        <DetailRow label={"Roster Size"}
                   color={(cCount >= role.minCount && cCount <= role.maxCount) ? "good" : "bad"}
                   value={roleChildIDs.length + " (Must be " + role.minCount + " - " + role.maxCount + ")"}
        />
        {/* List of current child role entries */}
        <DeviceItemList deviceIDs={roleChildIDs} removeAction={props.removeChildFn}/>
        {/* Optional button to add another child role entry */}
        {canAddChild &&
            <div className={"center-row"}>
                <Button variant="contained" color={"primary"}
                        onClick={props.addChildFn}>
                    <strong>Add Child</strong>
                </Button>
            </div>
        }
    </Paper>;
}

export default DeviceFamilyTab;